export default "__VITE_ASSET__BrklDN7H__"